import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, LayoutDashboard, Layers, Users, Plug, Settings as SettingsIcon, Shield, CreditCard, BarChart3, Store } from "lucide-react";

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/templates", label: "Templates", icon: Layers },
    { to: "/marketplace", label: "Marketplace", icon: Store },
    { to: "/leads", label: "Leads", icon: Users },
    { to: "/analytics", label: "Analytics", icon: BarChart3 },
    { to: "/integrations", label: "Integrations", icon: Plug },
    { to: "/pricing", label: "Pricing", icon: CreditCard },
    { to: "/settings", label: "Settings", icon: SettingsIcon },
  ];
  if (user?.role === "admin") {
    navItems.push({ to: "/admin", label: "Admin", icon: Shield });
  }

  const planLabel = user?.role === "admin" ? "ADMIN · UNLIMITED"
    : user?.plan === "pro_monthly" ? "PRO MONTHLY"
    : user?.plan === "pro_yearly" ? "PRO YEARLY"
    : "FREE PLAN";

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b-2 border-black bg-white sticky top-0 z-40">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/dashboard" className="flex items-center gap-3" data-testid="logo-link">
            <div className="w-9 h-9 bg-[#FF4F00] border-2 border-black flex items-center justify-center font-display font-black text-white">V</div>
            <span className="font-display font-black text-2xl tracking-tight">VIBELEAD</span>
          </Link>
          <div className="hidden md:flex items-center gap-4">
            <span className="label-cap" data-testid="plan-label">{planLabel}</span>
            <span className="text-sm font-medium text-zinc-600">{user?.email}</span>
            <button onClick={async () => { await logout(); navigate("/"); }} className="btn-brutal-outline !px-3 !py-2 text-sm" data-testid="logout-btn">
              <LogOut size={14} /> Logout
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-[1400px] mx-auto grid grid-cols-12 gap-0 min-h-[calc(100vh-73px)]">
        <aside className="col-span-12 md:col-span-2 border-r-2 border-black bg-zinc-50">
          <nav className="p-4 sticky top-[73px]">
            {navItems.map((item) => {
              const active = location.pathname === item.to || location.pathname.startsWith(item.to + "/");
              const Icon = item.icon;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                  className={`flex items-center gap-3 px-4 py-3 mb-1 border-2 font-bold transition-all ${active ? "bg-black text-white border-black" : "bg-white text-black border-transparent hover:border-black"}`}
                >
                  <Icon size={16} />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </aside>

        <main className="col-span-12 md:col-span-10 p-6 md:p-10 bg-white">
          {children}
        </main>
      </div>
    </div>
  );
}
